module.exports = __webpack_public_path__ + "img/vip1.8f7432a2.png";